import React, { useState } from 'react';
import Linkify from 'react-linkify';
import './editMyBump.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, faXmark } from '@fortawesome/free-solid-svg-icons';

const PreviewBumpPopup = ({ isOpen, onClose, content }) => {
    const [copied, setCopied] = useState(false);

    if (!isOpen) return null;

    const componentDecorator = (href, text, key) => (
        <a href={href} key={key} target="_blank" rel="noopener noreferrer" className="aibump-linkified">
            {text}
        </a>
    );

    const wrapHashtagsAndTimestamps = (text) => {
        const hashtagRegex = /(#\w+)/g;
        const timestampRegex = /\b(\d{1,2}:\d{2}(?::\d{2})?)\b/g;

        const parts = text.split(/(#\w+|\b\d{1,2}:\d{2}(?::\d{2})?\b)/g);

        return parts.map((part, index) => {
            if (hashtagRegex.test(part)) {
                return <span key={index} className="aibump-hashtag">{part}</span>;
            }
            if (timestampRegex.test(part)) {
                return <span key={index} className="aibump-timestamp">{part}</span>;
            }
            return part;
        });
    };

    const handleBumpAICopy = () => {
        navigator.clipboard.writeText(content);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="editBump-popup-overlay" onClick={onClose}>
            <div className="editBump-popup-content" onClick={(e) => e.stopPropagation()}>
                <div className="editBump-popup-header">
                    <div className="editBump-popup-title">Bump AI Description</div>
                    <div className="editBump-popup-actions">
                        <button className="editBump-close-btn" onClick={handleBumpAICopy} title={copied ? 'Copied' : 'Copy'} aria-label="Copy description">
                            <FontAwesomeIcon icon={copied ? faCheck : faCopy} className={copied ? 'is-copied' : ''} />
                        </button>
                        <button className="editBump-close-btn" onClick={onClose} aria-label="Close">
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
                </div>
                <div className="editBump-popup-inner-content-preview">
                    <Linkify componentDecorator={componentDecorator}>
                        {wrapHashtagsAndTimestamps(content)}
                    </Linkify>
                </div>
            </div>
        </div>
    );
};

export default PreviewBumpPopup;
